module.exports = "/wp-content/plugins/farmacy/assets/js/images/magnify-icon-06781488e7d60ede489777366baee17f.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/menu/menu-item-expanded/img/magnify-icon.png
 ** module id = 1039
 ** module chunks = 1 16
 **/